import { Component, OnInit } from '@angular/core';
import { CustomerEndpoint } from '@dato-proxy/endpoints/customer.endpoint';
import { ContactPerson } from '@dato-proxy/entities/contactperson.entity';
import { CredentialResult } from '@dato-proxy/entities/credentialresult.entity';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { LoginService } from '@m4u-angular/core/framework/login.service';
import { EnumPageDisplayModes } from '@m4u-angular/core/framework/sysenums.enum';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';

class State extends BaseState {
    Credentials: CredentialResult[] = [];
    ContactPersons: ContactPerson[] = [];
    CustomerID: number;
    ContactPersonID: number;
    IsUseContactPerson: boolean;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-credential-selector',
    templateUrl: './credential-selector.component.html',
    styleUrls: ['./credential-selector.component.scss']
})
export class CredentialSelectorComponent extends BasePageComponent<BaseEntity, State> {
    constructor(A: ServiceBagService,
        public customerEndpoint: CustomerEndpoint,
        public loginService: LoginService) {
        super(A, 'CredentialSelectorComponent', BaseEntity, State, EnumPageDisplayModes.Window);
    }

    override OnInitComponent() {
        this.State.IsUseContactPerson = this.A.Framework.SystemOptionFlag("IsUseContactPerson");
        this.DataSources['Credentials'] = new DataSourceCustomAction(() => this.customerEndpoint.GetCredentials());
        this.customerEndpoint.GetCredentials()
            .subscribe(r => {
                this.State.Credentials = r.Entities;
            });
    }

    OnCustomerChanged() {
        if (!this.State.IsUseContactPerson) return;

        this.State.ContactPersonID = null;
        this.State.ContactPersons = this.State.CustomerID ? this.State.Credentials.find(x => x.EntryID === this.State.CustomerID).ContactPersons : [];
        if (this.State.ContactPersons && this.State.ContactPersons.length === 1) {
            this.State.ContactPersonID = this.State.ContactPersons[0].EntryID;
        }
    }

    Impersonate() {
        if (this.State.IsUseContactPerson) {
            this.State.ContactPersonID && this.loginService.ImpersonateLogin(this.State.ContactPersonID);
        } else {
            this.State.CustomerID && this.loginService.ImpersonateLogin(this.State.CustomerID);
        }
    }
}
